import moment from 'moment';
import React, { useEffect, useState } from 'react';
import LdcApi from '../../../LdcApis';
import { Table } from 'react-bootstrap';
import { DatePicker, Empty, Skeleton } from 'antd';
import 'moment-timezone';
import dayjs from 'dayjs';
import { all } from 'async';

const simpleToggleStyles = `
.simple-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  border-radius: 8px;
  padding: 6px 12px;
  border: 1px solid #f3f3f3;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); /* added shadow */
}


  .toggle-switch {
    position: relative;
    width: 44px;
    height: 22px;
    background-color: #e5e7eb;
    border-radius: 11px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .toggle-switch.active {
    background-color: #5c96b1;
  }

  .toggle-knob {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .toggle-knob.active {
    transform: translateX(22px);
  }
`;

const DoctorHours = () => {
  useEffect(() => {
    document.title = 'Doctor Hours - LDC';
  }, []);
  function formatDateToYYYYMMDD(date) {
    // Ensure the parameter is a Date object; if not, use the current date
    const currentDate = date instanceof Date ? date : new Date();
    // Extract year, month, and day
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = currentDate.getDate().toString().padStart(2, '0');
    // Format the date
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  // Get the current date and time in the UK time zone
  // const now = moment().tz('Europe/London');

  // Calculate 1 month ago from the current date
  // const threeMonthsAgo = now.clone().subtract(1, 'months');

  const now = new Date();
  const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth(), 1);
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth());

  // Set the default value for the RangePicker
  const defaultValue = [
    dayjs(formatDateToYYYYMMDD(threeMonthsAgo)),
    dayjs(formatDateToYYYYMMDD(now)),
  ]; // RangePicker takes an array of two moment objects

  // State to hold the selected date range
  const [selectedRange, setSelectedRange] = useState(defaultValue);
  //   const [date, setDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [finalDateRange, setFinalDateRange] = useState({
    startDate: '',
    endDate: '',
  });
  const [showAllDoctors, setShowAllDoctors] = useState(false);
  console.log('showAllDoctors', showAllDoctors);
  const [DateRangesss, setDateRangess] = useState({
    startDate: '',
    endDate: '',
  });
  const [loading, setLoading] = useState(false);
  const [eodMonthlyData, setEodMonthlyData] = useState([]);
  const [allDoctorData, setAllDoctorData] = useState([]);
  console.log('allDoctorData', allDoctorData);
  const [monthTotal, setMonthTotal] = useState(0);
  const { RangePicker } = DatePicker;
  const dateFormat = 'DD/MM/YYYY';
  const [allDoctor, setAllDoctor] = useState([]);
  const [selectDoctorForFilter, setSelectDoctorForFilter] = useState('');
  useEffect(() => {
    LdcApi({
      method: 'GET',
      url: `Doctor/GetDoctorDetail`,
    })
      .then((response) => {
        setAllDoctor(response.data);
      })
      .catch((error) => {});
  }, []);
  function formatDate(dateObj) {
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 to get the correct month (0-indexed)
    const day = dateObj.getDate().toString().padStart(2, '0');
    const year = dateObj.getFullYear();

    return `${month}-${year}-${day}`;
  }

  useEffect(() => {
    if (selectedRange) {
      const ukStartDate = selectedRange[0]['$d'];
      const ukEndDate = selectedRange[1]['$d'];
      const startDate = formatDate(ukStartDate);
      const endDate = formatDate(ukEndDate);

      if (showAllDoctors) {
        getAllDoctorsHourData(startDate, endDate, selectDoctorForFilter);
      } else {
        getDoctorHourData(startDate, endDate, selectDoctorForFilter);
      }
    }
  }, [selectDoctorForFilter, selectedRange, showAllDoctors]);

  // useEffect(() => {
  //     if (selectedRange) {
  //         const ukStartDate = selectedRange[0][`$d`];
  //         const ukEndDate = selectedRange[1][`$d`];
  //         const startDate = formatDate(ukStartDate);
  //         const endDate = formatDate(ukEndDate)
  //         getDoctorHourData(startDate, endDate, selectDoctorForFilter);
  //     }
  // }, [selectDoctorForFilter, selectedRange])
  // total count data
  useEffect(() => {
    const totalMinutes = eodMonthlyData.reduce((accumulator, currentValue) => {
      const [hours, , minutes] = currentValue.totalHours.split(' ');
      const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
      return accumulator + totalMinutes;
    }, 0);
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    setMonthTotal(
      `${totalHours} hours ${remainingMinutes !== 0 ? remainingMinutes + ` minutes` : ``} `
    );
  }, [eodMonthlyData]);
  
  useEffect(() => {
    const totalMinutes = allDoctorData.reduce((accumulator, currentValue) => {
      const [hours, , minutes] = currentValue.totalHours.split(' ');
      const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
      return accumulator + totalMinutes;
    }, 0);
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    setMonthTotal(
      `${totalHours} hours ${remainingMinutes !== 0 ? remainingMinutes + ` minutes` : ``} `
    );
  }, [allDoctorData]);
  const onChange = (date, dateString) => {
    setFinalDateRange({
      ...DateRangesss,
      startDate: dateString[0],
      endDate: dateString[1],
      // .split('-').reverse().join('-')
    });
  };

  // useEffect(() => {
  //     var date = new Date();
  //     var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  //     setDateRangess({
  //         ...DateRangesss,
  //         startDate: moment(firstDay).format('YYYY/MM/DD'),
  //         endDate: moment(new Date()).format('YYYY/MM/DD')
  //     });
  // }, []);

  const handleSelectDoctor = (e) => {
    setSelectDoctorForFilter(e.target.value);
    setShowAllDoctors(false);
  };
  const handleDateChange = (dates) => {
    setSelectedRange(dates);
  };

  const getAllDoctorsHourData = (startDate, endDate, selectDoctorForFilter) => {
    setLoading(true);
    LdcApi({
      method: 'GET',
      url: `Chamber/GetChamberDetailsByDoctor?starttime=${startDate}&endtime=${endDate}`,
    })
      .then((response) => {
        console.log('response', response);
        setAllDoctorData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getDoctorHourData = (startDate, endDate, selectDoctorForFilter) => {
    if (selectDoctorForFilter) {
      setLoading(true);
      LdcApi({
        method: 'GET',
        url: `Chamber/GetChamberDetailsByDoctor?doctorId=${selectDoctorForFilter}&starttime=${startDate}&endtime=${endDate}`,
      })
        .then((response) => {
          setEodMonthlyData(response.data);

          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setEodMonthlyData([]);
    }
  };
  return (
    <div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          className='d-flex align-items-center my-4'
          style={{ color: 'gray' }}
        >
          <b className='mr-2'>Date Range : </b>
          {/* <RangePicker
                        format={dateFormat}
                        onChange={onChange}
                        defaultValue={[
                            moment(moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('YYYY/MM/DD')),
                            moment(moment(new Date()).format('YYYY/MM/DD'))
                        ]}
                    /> */}
          <RangePicker
            value={selectedRange}
            onChange={handleDateChange}
            format='DD-MM-YYYY'
          />
        </div>
        {/* <button
          className='btn btn-primary ml-2'
          onClick={() => {
            setShowAllDoctors((prev) => !prev);
            setSelectDoctorForFilter(''); // reset individual doctor filter when toggling
          }}
        >
          {showAllDoctors ? 'Show Individual Doctor' : 'Show All Doctors'}
        </button> */}

        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <div className='simple-toggle' style={{ marginRight: '20px' }}>
            <style>{simpleToggleStyles}</style>
            <span
              style={{
                color: !showAllDoctors ? '#6b7280' : '#6b7280',
                fontSize: '16px',
                fontWeight: '500',
              }}
            >
              Show All Doctors
            </span>
            <div
              className={`toggle-switch ${showAllDoctors ? 'active' : ''}`}
              onClick={() => {
                setShowAllDoctors((prev) => !prev);
                setSelectDoctorForFilter('');
              }}
            >
              <div
                className={`toggle-knob ${showAllDoctors ? 'active' : ''}`}
              ></div>
            </div>
          </div>

          <div>
            <select
              onChange={handleSelectDoctor}
              value={selectDoctorForFilter}
              className='form-control doctor-slot-select'
              style={{
                width: 'max-content',
                height: '40px',
                paddingTop: '0px',
                paddingBottom: '0px',
                fontWeight: '500',
              }}
            >
              <option value=''>Search For Doctor</option>
              {allDoctor.map((item) => {
                return <option value={item.id}>{item.name}</option>;
              })}
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <>
          <Skeleton />
        </>
      ) : (
        <>
          {showAllDoctors ? (
            allDoctorData.length > 0 ? (
              <Table
                responsive
                className='table table-bordered'
                id='bootstrap_table'
              >
                <thead id='bootstrap_table_head'>
                  <tr>
                    <th scope='col' style={{ minWidth: 50, maxWidth:50}}>
                      Doctor Name
                    </th>
                    <th scope='col' style={{ minWidth: 50, maxWidth:50 }}>
                      {' '}
                      Total Hours
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allDoctorData.map((el, i) => {
                    const originalDate = new Date(el.chamberDate);
                    const day = originalDate
                      .getDate()
                      .toString()
                      .padStart(2, '0');
                    const month = (originalDate.getMonth() + 1)
                      .toString()
                      .padStart(2, '0');
                    const year = originalDate.getFullYear();
                    const formattedDateString = `${day}/${month}/${year}`;
                    return (
                      <tr key={i}>
                        <td>
                          <div>{el.doctorName}</div>
                        </td>
                        <td>
                          <div>{el.totalHours}</div>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className='border_top'>
                    <td style={{ fontWeight: 'bold' }}>Grand Total</td>
                    <td style={{ fontWeight: 'bold' }}>{monthTotal}</td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <h2 style={{textAlign:'center'}}>No Doctors Available</h2>
            )
          ) : eodMonthlyData.length > 0 ? (
            <Table
              responsive
              className='table table-bordered'
              id='bootstrap_table'
            >
              <thead id='bootstrap_table_head'>
                <tr>
                  <th scope='col' style={{ minWidth: 200 }}>
                    Date
                  </th>
                  <th scope='col' style={{ minWidth: 200 }}>
                    Start Time
                  </th>
                  <th scope='col' style={{ minWidth: 200 }}>
                    End Time
                  </th>
                  <th scope='col' style={{ minWidth: 200 }}>
                    Total Hour
                  </th>
                </tr>
              </thead>
              <tbody>
                {eodMonthlyData.map((el, i) => {
                  const originalDate = new Date(el.chamberDate);
                  const day = originalDate
                    .getDate()
                    .toString()
                    .padStart(2, '0');
                  const month = (originalDate.getMonth() + 1)
                    .toString()
                    .padStart(2, '0');
                  const year = originalDate.getFullYear();
                  const formattedDateString = `${day}/${month}/${year}`;
                  return (
                    <tr key={i}>
                      <td>
                        <div>{formattedDateString}</div>
                      </td>
                      <td>
                        <div>{el.timeStart}</div>
                      </td>
                      <td>
                        <div>{el.timeEnd}</div>
                      </td>
                      <td>
                        <div>{el.totalHours}</div>
                      </td>
                    </tr>
                  );
                })}
                <tr className='border_top'>
                  <td colSpan={3} style={{ fontWeight: 'bold' }}>
                    TOTAL
                  </td>
                  <td style={{ fontWeight: 'bold' }}>{monthTotal}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
              }}
            >
              {selectDoctorForFilter ? (
                <p>No records to show</p>
              ) : (
                <h4 style={{ opacity: '0.7' }}>Select a doctor first</h4>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DoctorHours;
